import React, { FC, useEffect, useMemo, useRef } from 'react'

import CalendarShiftsList from '../CalendarShiftsList/CalendarShiftsList'
import DayContent from '../DayContent/DayContent'
import DayHeader from '../DayHeader/DayHeader'
import { filterShiftsByDays, getHeader } from './helpers'
import { DayBasis } from './models'

import './Day.scss'


interface DayProps extends DayBasis {
    day: Date
    index: number
    last: boolean
    outOfRange: boolean
    showDate: boolean
}

const Day: FC<DayProps> = ({
    day,
    shifts,
    showHeader,
    index,
    outOfRange,
    showDate,
    last,
}) => {
    const todayRef = useRef<HTMLDivElement>(null)
    const filteredShifts = useMemo(() => filterShiftsByDays(shifts, day), [shifts, day])
    const isToday = useMemo(() => new Date().toDateString() === day.toDateString(), [day])

    const header = getHeader(day)

    useEffect(() => {
        if (! todayRef.current) {
            return
        }

        todayRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, [todayRef, isToday, shifts])

    return (
        <div
            ref={isToday ? todayRef : undefined}
            className={`day calendar-day ${outOfRange ? 'day--out-of-range' : ''}`}
            style={{ zIndex: (100 - index) }}
        >
            { showHeader && <DayHeader header={header} /> }
            <DayContent day={day} showHeader={showDate}>
                {!! (filteredShifts.length) && (
                    <CalendarShiftsList shifts={filteredShifts} />
                )}
            </DayContent>
        </div>
    )
}

export default Day
